import { useCallback } from "react"
import { useLocation, useNavigate } from "react-router-dom"

interface UseNavigationWithSearchReturn {
  navigateWithSearch: (targetPath: string) => void
  goBack: () => void
}

export const useNavigationWithSearch = (): UseNavigationWithSearchReturn => {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()

  const navigateWithSearch = useCallback(
    (targetPath: string): void => {
      navigate(`${targetPath}${search}`)
    },
    [navigate, search]
  )

  const goBack = useCallback((): void => {
    const path = pathname.split("/").slice(0, -1).join("/")
    const safePath = path === "" ? "/" : path

    navigate(`${safePath}${search}`)
  }, [navigate, pathname, search])

  return { navigateWithSearch, goBack }
}
